import { useEffect, useState } from "react";
import { Pie, PieChart, Cell } from 'recharts';
import { collection, doc, getDoc, getDocs, getFirestore, limit, onSnapshot, orderBy, query, Timestamp, where } from "firebase/firestore";



var names = [
    "DM",
    "Video Request",
    "Event Bookings"
];


const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text className="text-md font-bold" x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`} {names[index]}
        </text>
    );
};

const COLORS = ['#DA50CA', '#00C49F', '#604BE8']


export default function RequestsDistribution(props) {

    const db = getFirestore();
    const [data, setData] = useState(
        [
            { name: 'DM', value: 100 },
            { name: 'Video Requests', value: 300 },
            { name: 'Event Bookings', value: 700 },
        ]
    );

    const [numbers,setNumbers]=useState(new Map());

    useEffect(async() => {

        const q = query(collection(db, "requests"));
        const querySnapshot = await getDocs(q);

        var tempMap=new Map();
        tempMap.set("dm",0);
        tempMap.set("videoRequest",0);
        tempMap.set("eventBooking",0);

        querySnapshot.forEach(element => {

            if(element.data()["type"]=="dm"){
                var tempValue=tempMap.get("dm");
                tempMap.set("dm",tempValue+1);
            }
            if(element.data()["type"]=="videoRequest"){
                var tempValue=tempMap.get("videoRequest");
                tempMap.set("videoRequest",tempValue+1);
            }
            if(element.data()["type"]=="eventBooking"){
                var tempValue=tempMap.get("eventBooking");
                tempMap.set("eventBooking",tempValue+1);
            }

        });

        setData(
            [
                { name: 'DM', value: tempMap.get("dm") },
                { name: 'Video Requests', value: tempMap.get("videoRequest") },
                { name: 'Event Bookings', value: tempMap.get("eventBooking") },
            ]
        );


        setNumbers(tempMap);


    }, []);

    return (
        <div>
            <div className="h-[600px] w-full flex justify-center items-center bg-white/10">

                <div className="w-3/5 h-full bg-white/10 p-4">
                    <PieChart width={600} height={600}>
                        <Pie
                            labelLine={false}
                            label={renderCustomizedLabel}
                            data={data}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={200}
                            fill="#8884d8" >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                    </PieChart>
                </div>

                <div className="w-2/5 bg-white/20 h-full flex justify-center items-center">

                    <div className="flex flex-col w-full justify-evenly p-4">

                        <div className="text-6xl font-bold pl-4 pb-4"> Requests Overview</div>

                        <div className="flex flex-row justify-evenly items-center p-4 gap-4">
                            <div className="h-4 w-24 bg-[#DA50CA]"></div>
                            <div className="h-4 w-full flex justify-start items-center text-xl font-bold" >Messages: {numbers.get("dm")}</div>
                        </div>

                        <div className="flex flex-row justify-evenly items-center p-4 gap-4">
                            <div className="h-4  w-24 bg-[#00C49F]"></div>
                            <div className="h-4 w-full flex justify-start items-center text-xl font-bold" >Video Requests: {numbers.get("videoRequest")}</div>
                        </div>

                        <div className="flex flex-row justify-evenly items-center p-4 gap-4">
                            <div className="h-4 w-24 bg-[#604BE8]"></div>
                            <div className="h-4 w-full flex justify-start items-center text-xl font-bold" >Event Bookings: {numbers.get("eventBooking")}</div>
                        </div>

                    </div>

                </div>



            </div>
        </div>
    )

}